import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { StockProperty1 } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class StockProperty1Service extends TmsWebBaseEditCreateService<StockProperty1, StockProperty1> {
  constructor() {
    super('StockProperty1', $localize`Stock Property`);
  }

  getForStockPropertyHeader(id: string): Observable<StockProperty1[]> {
    return this.httpService.get<StockProperty1[]>(`${this.apiUrl}/GetForStockPropertyHeader?id=${id}`);
  }
}
